import axios from "axios";
import { API } from "../../utils";
const instance = axios.create();

export const getProductTypes = async () => {
  return instance.get(`${API}/type`);
};
